<div class="header">
  <h3>รายงานภาษีขายรายเดือน</h3>
</div>

<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading" (search)="search()" (clear)="clearData()"></app-filter-header>
  <div class="row align-items-center m-t-10">
    <div class="col-md-6">
      <div class="dropdown" #dd="ngbDropdown" ngbDropdown autoClose="outside">
        <div class="form-label-group">
          <input #ddi class="form-control" type="text" id="calendarDropdown" [value]="selectedMonthLabel" ngbDropdownToggle
            placeholder="ค้นหาจากเดือน" readonly>
          <label for="calendarDropdown">ค้นหาจากเดือน</label>
          <div class="calendar-trigger" (click)="$event.stopPropagation(); dd.toggle()">
            <span class="far fa-calendar"></span>
          </div>
        </div>
        <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="calendarDropdown">
          <div class="row">
            <div class="col" style="padding-left: 30px">เดือน</div>
          </div>
          <div (click)="$event.stopPropagation()">
            <p-calendar [(ngModel)]="selectedMonth" [dateFormat]="'mm/yyyy'" (onSelect)="getSelectedMonth($event)" view="month" readonlyInput="true" [showIcon]="true"
              [inline]="true" [locale]="calendarLocale"></p-calendar>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-label-group">
        <input class="form-control" type="text" id="searchInput" [(ngModel)]="searchInput" placeholder="ค้นหา">
        <label for="searchText">ค้นหา</label>
      </div>
    </div>
  </div>
</div>

<div class="box-parent position-relative z-1">
  <div class="row">
    <div class="col-md-6">
      <!-- <app-custom-pagination [(currentPage)]="currentPage" [(itemsPerPage)]="itemsPerPage" [totalItems]="totalItems"
        (pageChange)="pageChanged()" (optionChange)="optionChanged()">
      </app-custom-pagination> -->
    </div>
  </div>

  <div class="scrollable m-t-30">
    <table class="table text-center">

    </table>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/saletax/saletax.component.html